// import { BASE_URL } from '@/api/url';
// import BaseFuncApi from '@/api/base/commonFunc-api';
// import Enum from '@/enum/enum';
import SupplierClient from "@/api/supplier/supplier-client";
const supplierClient = new SupplierClient();
export default {
  createSupplier: async function (context, payload) {
    var result = await supplierClient.postAsync(
      {
        url: `${supplierClient.url}`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  updateSupplier: async function (context, payload) {
    var result = await supplierClient.putAsync(
      {
        url: `${supplierClient.url}/${payload.id}`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  deleteSupplier: async function (context, payload) {
    var result = await supplierClient.deleteAsync(
      {
        url: `${supplierClient.url}/${payload.id}`
      },
      true
    );
    return result;
  },

  getSupplier: async function (context, payload) {
    var result = await supplierClient.getAsync(
      {
        url: `${supplierClient.url}/${payload.id}/detail`,
        data: payload,
      },
      true
    );
    if (result && result.data) {
      return result.data;
    }
    return null;
  },

  getSuppliers: async function (context, payload) {
    var result = await supplierClient.getAsync(
      {
        url: `${supplierClient.url}/search`,
        queries: payload
      },
      true
    );
    if (result && result.data) {
      context.commit("updateTotalPage", result.data);
      return result.data;
    }
    return null;
  },

  getSuppliersList: async function (context, payload) {
    var result = await supplierClient.getAsync(
      {
        url: `${supplierClient.url}/search`,
        queries: payload
      },
      true
    );
    if (result && result.data) {
      context.commit("updateSuppliers", result.data.rows);
      return result.data.rows;
    }
    return [];
  },
};
